import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 20px;
  .container_select_campaign_objective {
    display: grid;
    column-gap: 24px;
    grid-template-columns: repeat(3, 1fr);
    align-items: flex-start;
    margin-top: 8px;
    margin-bottom: 40px;
    .component_title {
      margin-bottom: 12px;
    }
  }
`;

export default Wrapper;
